import React from "react";
import DefaultIcon from '../assets/icons/dropdown-icon-default.svg';
import ActiveIcon from '../assets/icons/dropdown-icon-active.svg';
import HoverIcon from '../assets/icons/dropdown-icon-hover.svg';

const AdvanceModeBtn = ({
  isAdvOpen,
  setIsAdvOpen,
  forms,
  setForms,
  textareaRef,
  addDepsRef,
  errorsRef,
  setErrorsActivated,
  displayErrors,
  scrollToTarget,
  isValidVersion
}) => {
  const handleToggleMode = () => {
    if (!isAdvOpen && displayErrors() === null) /*no errors*/ {
      setErrorsActivated(false);
      setIsAdvOpen(!isAdvOpen);
    } else if (!isAdvOpen && displayErrors() !== null) /*has errors*/ {
      //Don't open, display errors
      scrollToTarget(errorsRef); 
      setErrorsActivated(true);
    } else if (isAdvOpen) /*advance mode open*/ {
      //reset advance section
      setForms([forms[0], {
          id: 'm',
          type: 'metadata',
          name: '',
          link: ''
        }]);
      if (addDepsRef && addDepsRef.current) {
      addDepsRef.current.classList.remove('add-dependency-btn');
      addDepsRef.current.innerHTML = `
        <div class="mc-button mc-btn-wh">
          <div class="mc-btn-con">
            <p>Create Dependency</p>
          </div>
        </div>`;
      }
      if (forms[0].name !== '' && forms[0].selectedOpt !== '' && isValidVersion(forms[0].version)) {
        // if required form contains no errors
        setErrorsActivated(false);
      }
      textareaRef.current.value = '';
      setIsAdvOpen(!isAdvOpen);
    }
  };
  
  return (
    <div className="group advance-mode__link hover:bg-[#8e8e8e2b] hover:text-white active:bg-[#8e8e8e] active:text-black" onClick={handleToggleMode}>
       <p>Advance Mode</p>
       <img className="dropdown-icon-default group-hover:hidden group-active:hidden" src={DefaultIcon}/>
       <img className="dropdown-icon-active group-hover:hidden group-active:block" src={ActiveIcon}/>
       <img className="dropdown-icon-hover group-hover:block group-active:hidden" src={HoverIcon}/>
    </div>
  );
}

export default AdvanceModeBtn;